export const Config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  },

  baseUrl: import.meta.env.VITE_BACKEND_BASE_URL,
  install: 'install',
  store: 'store/',
  settings: 'settings',
  user: 'user/',
  users: 'users/',

  loginCode: 'login-code/',
  loginCodes: 'login-codes',

  locations: 'locations',
  cartLayouts: 'cart_layouts',
  cartLayout: 'cart_layout/',
  orderShipments: 'order_shipments',
  orderShipmentsPrepare: 'order_shipments/prepare',
  orderShipmentsConvertToTotes: 'order_shipments/convert_to_totes',

  totes: 'totes',
  tote: 'tote/',
  totesUndo: 'totes/undo',
  totesDelete: 'totes/delete',

  batches: 'batches',
  batchesStats: 'batches/stats',
  batchesPdf: 'batches/pdf',
  batch: 'batch/',

  packingRules: 'packing_rules',
  packingRule: 'packing_rule/',

  productsSearch: 'products/search',
  collections: 'collections',
  tags: 'tags',

  auditLogs: 'audit_logs'
}
